<template>
  <button
    type="button"
    class="btn btn-tertiary btn-lg save-close ignore"
    :disabled="disabled"
    @click="submit"
  >
    <translation :text="lang.get('buttons.saveClose')" />
  </button>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  inject: ['lang'],
  computed: {
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isSaveable ||
        !this.isLoaded ||
        this.ajaxInProgress
      );
    },
    ...mapState('entryForm', ['uploadInProgress']),
    ...mapGetters('entryForm', ['isSaveable', 'isLoaded']),
    ...mapState('entryFormApi', ['ajaxInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    ...mapActions('entryFormApi', { submit: 'saveAndClose' })
  }
};
</script>
